import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import {
  useRefresh,
  useNotify,
  useMutation,
  Button,
  SimpleForm,
  useDataProvider,
} from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { useFormState } from "react-final-form";
import SanitizedGrid from "../../../components/SanitizedGrid";
import NoteInput from "../../../components/NoteInput";
import { StyledButton } from "../../../components/ListShowButton";

interface INoteCommercialDocumentButton {
  commercialDocumentId: string;
}

const CustomConfirmButton = ({
  commercialDocumentId,
}: INoteCommercialDocumentButton) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const { values } = useFormState();

  const [handleUpdateNoteCommercialDocument, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `commercialDocuments/${commercialDocumentId}/note`,
      payload: {
        data: {
          CommercialDocumentId: Number(commercialDocumentId),
          Note: values.note,
        },
      },
    },
    {
      onSuccess: () => {
        notify(`Successfully update note commercial document.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed update note the commercial document, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleUpdateNoteCommercialDocument}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

const InternalNoteParentButton = ({
  commercialDocumentId,
}: INoteCommercialDocumentButton) => {
  const [commercialDocument, setCommercialDocument] = useState<any>();
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();
  const provider = useDataProvider();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getCommercialDocument = (commercialDocumentId: number) => {
    provider
      .getOneAxios("commercialDocuments", { id: commercialDocumentId })
      .then((data: any) => {
        setCommercialDocument(data.data);
      });
  };

  useEffect(() => {
    if (open) {
      getCommercialDocument(Number(commercialDocumentId));
    }
  }, [open]);

  return (
    <Fragment>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Set Note
      </StyledButton>

      {open && (
        <SimpleForm toolbar={null}>
          <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.dialog}
            fullWidth
          >
            <DialogTitle id="alert-dialog-title">
              Note Commercial Document
            </DialogTitle>
            <DialogContent>
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12}>
                  <NoteInput record={commercialDocument} />
                </Grid>
              </SanitizedGrid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="secondary" label="Back" />
              <CustomConfirmButton
                commercialDocumentId={commercialDocumentId}
              />
            </DialogActions>
          </Dialog>
        </SimpleForm>
      )}
    </Fragment>
  );
};

export default InternalNoteParentButton;
